import React from 'react'

import InfoBox from '../../../react4xp/components/InfoBox'

function InfoBoxPart({ title, intro, bgColor, cta }) {
    return (
        <InfoBox
            section={{
                bgColor: bgColor
            }}
            title={title}
            text={intro}
            cta={{
                text: cta.text,
                href: cta.href,
                external: cta.isExternal
            }}
        />
    )
}

export default (props) => <InfoBoxPart {...props} />
